import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import useStyles from '../styles';
import ModalBody from '@components/Modals/components/ModalBody';
import ModalBreadcrumb from '@components/Modals/components/ModalBreadcrumb';
import ModalContent from '@components/Modals/components/ModalContent';
import ModalHeader from '@components/Modals/components/ModalHeader';
import ContentCarousel from '@components/UI/ContentCarousel';
import SelectTransactionAmount from '@components/Modals/components/SelectTransactionAmount';
import completePaypalDeposit from '@api/payment/completePaypalDeposit';
import { generateCorrelationId } from '@helpers/correlationId';
import PaymentMethod from '@components/Modals/AddFunds/components/PaymentMethod';
import Complete from '@components/Modals/AddFunds/components/Complete';
import SelectPaymentProvider from '../SelectPaymentProvider';
import { useCallback, useState } from 'react';
import AuthorizeNetPayment from '../AuthorizeNetPayment';
import { useFeature } from 'flagged';
const DepositCash = ({ onClose, onNavigateCurrencyStep, onNavigateAmountStep, onNavigatePaymentProviderStep, breadcrumbIndex, setBreadcrumbIndex, transactionAmount, setTransactionAmount, paymentStatus, setPaymentStatus, error, setError, paypalOrderId, setPaypalOrderId, transactionWarningModalData, setTransactionWarningModalData, preSelectedCurrency = false, }) => {
    const { classes } = useStyles();
    const hideCrumbs = preSelectedCurrency ? [0] : [];
    const [paymentProvider, setPaymentProvider] = useState('paypal');
    const isUsePaymentMicroserviceEnabled = !!useFeature('use_payment_microservice');
    const isEnableAuthorizeNet = !!useFeature('enable_authorize_net');
    const isAuthorizeNetEnabled = isUsePaymentMicroserviceEnabled && isEnableAuthorizeNet;
    const getPaymentProviderComponent = useCallback(() => {
        if (breadcrumbIndex !== 3) {
            return 'Payment Form';
        }
        return paymentProvider === 'paypal' ? 'Paypal' : 'Authorize.net';
    }, [breadcrumbIndex, paymentProvider]);
    const breadcrumbs = [
        {
            id: '0',
            component: 'Select Currency',
            onClick: () => onNavigateCurrencyStep(),
        },
        {
            id: '1',
            component: 'Amount',
            onClick: () => onNavigateAmountStep(),
        },
        {
            id: '2',
            component: 'Payment Provider',
            onClick: () => onNavigatePaymentProviderStep(),
        },
        {
            id: '3',
            component: getPaymentProviderComponent(),
        },
    ];
    const handleClose = () => {
        if (paypalOrderId && paymentStatus === 'WAITING') {
            // If the user closed the whole modal when there was a paypal order ID but the state suggests
            // nothing is completed or in process, cancel the payment_order.
            // Best effort - kick it off and ignore any errors.
            void completePaypalDeposit({
                paypalOrderId,
                newOrderState: 'cancelled',
            }, isUsePaymentMicroserviceEnabled, generateCorrelationId());
        }
        onClose();
    };
    const handleCashSelection = (value) => {
        setTransactionAmount(value);
        setBreadcrumbIndex(2);
    };
    const handleFinishProcess = () => {
        setBreadcrumbIndex(4);
    };
    const handleSelectPaymentProvider = (selectedPaymentProvider) => {
        setPaymentProvider(selectedPaymentProvider);
        setBreadcrumbIndex(3);
    };
    return (_jsxs(_Fragment, { children: [_jsx(ModalHeader, { title: "Deposit Cash", subtitle: "Add cash to your Account", icon: _jsx("img", { src: "/img/icons/dollar.svg", alt: "dollar", className: classes.closeButton }), onClose: handleClose }), _jsx(ModalBreadcrumb, { currentIndex: breadcrumbIndex, breadcrumbs: breadcrumbs, hideCrumbs: hideCrumbs, isVisible: true }), _jsx(ModalBody, { children: _jsxs(ContentCarousel, { currentStep: breadcrumbIndex - 1, name: "Deposit Cash", children: [_jsx(ModalContent, { children: _jsx(SelectTransactionAmount, { minAmount: 10, amountsArray: [10, 20, 50, 100, 500], onAmountSelected: handleCashSelection, palette: "primary" }) }), _jsx(SelectPaymentProvider, { onSelectPaymentProvider: handleSelectPaymentProvider, authorizeNetDisabled: !isAuthorizeNetEnabled }), paymentProvider === 'paypal' && (_jsx(PaymentMethod, { onFinishProcess: handleFinishProcess, setError: setError, setPaymentStatus: setPaymentStatus, setTransactionWarningModalData: setTransactionWarningModalData, setPaypalOrderId: setPaypalOrderId, paypalOrderId: paypalOrderId, currencyAmount: transactionAmount, currency: "USD", transactionAmount: transactionAmount, paymentStatus: paymentStatus })), paymentProvider === 'authorizeNet' && (_jsx(AuthorizeNetPayment, { onFinishProcess: handleFinishProcess, setError: setError, setPaymentStatus: setPaymentStatus, setTransactionWarningModalData: setTransactionWarningModalData, setPaypalOrderId: setPaypalOrderId, paypalOrderId: paypalOrderId, currencyAmount: transactionAmount, currency: "USD", transactionAmount: transactionAmount, paymentStatus: paymentStatus })), !transactionWarningModalData.isShow && (_jsx(Complete, { onClose: handleClose, onRetry: () => setBreadcrumbIndex(2), paymentStatus: paymentStatus, currency: "USD", transactionAmount: transactionAmount, currencyAmount: transactionAmount, error: error }))] }) })] }));
};
export default DepositCash;
